import { useAppConfig } from '@/providers';
import { useUserContextStore } from '@/shared/user-context';

import { RouteNames } from '../routeNames';

export async function useNoaSpaceVisibilityManagementGuard() {
  const { facilities } = useUserContextStore();
  const appConfig = useAppConfig();

  if (facilities.length === 0 && appConfig.MARKETING_LANDING_PAGE_URI) {
    window.location.href = appConfig.MARKETING_LANDING_PAGE_URI;

    return false;
  }

  if (facilities.length === 1) {
    return {
      name: RouteNames.NOA_SPACE_VISIBILITY_MANAGEMENT_FACILITY,
      params: { id: facilities[0].apiClientId, facilityId: facilities[0].id },
    };
  }

  return {
    name: RouteNames.NOA_SPACE_VISIBILITY_MANAGEMENT,
  };
}
